// The bottom bar's navigation-context rules, kept out of TabBar.tsx so they can
// be unit-tested: the component reaches the whole store graph, which transitively
// pulls several ESM-only packages CRA's jest does not transform, so nothing that
// imports TabBar can be rendered in a test.
//
// This covers only the "should the bar exist in this navigation context" half.
// Whether there are any tabs left to show (every app hidden / denied by
// permissions) stays in the component, since it depends on what actually rendered.

export interface TabBarNavigationContext {
  // Router `showBackButton`. Cleared by CommunicationManager.processAction when
  // the host app opens a single app through a direct-open SDK call.
  showBackButton: boolean;
  // Depth of the router history stack.
  historyLength: number;
}

export const hideTabBarForNavigation = ({
  showBackButton,
  historyLength,
}: TabBarNavigationContext): boolean => {
  // The direct-open APIs (openFeatureRequests(false), openNews(false), …) clear
  // showBackButton to open ONE app as a standalone view. The SDK docs define the
  // flag as governing "the main tabbar and back buttons" — both, not just the
  // back button — and leaving the bar up defeats the point of suppressing the
  // back button, since Home/Help stay one tap away (Gleap #143124).
  //
  // Only processAction sets this false, and it flips back to true when the
  // widget closes, so the bar returns on the next normal open.
  if (!showBackButton) {
    return true;
  }

  // Navigated deeper than the app's root — the header's back button owns
  // navigation from here.
  if (historyLength > 1) {
    return true;
  }

  return false;
};
